
import { Component, Vue, Prop } from "vue-property-decorator";
// import Avatar from "@/components/Avatar.vue";
import { formatAvatar } from "@/utils";
@Component({
  components: {}
})
export default class TeacherItem extends Vue {
  @Prop({ required: true }) private item!: any;
  formatAvatar = formatAvatar;
}
